import React from 'react';
import { ArrowRight } from 'lucide-react';
import { CANCEL_ANYTIME } from '../plans';
import { SectionHead } from './SectionHead';
import { PlanCards } from './PlanCards';

export const PricingPreview = ({ onAuth }) => (
  <section className="mk-section" id="pricing" aria-labelledby="pricing-title">
    <div className="mk-container">
      <SectionHead id="pricing-title" eyebrow="Pricing" title="Free trial, then one Pro plan" />
      <PlanCards onAuth={onAuth} />
      <div className="mk-pricing-foot">
        {CANCEL_ANYTIME && <p className="mk-fine" data-testid="cancel-anytime-note">Cancel anytime. Cancel during the trial and you are not charged.</p>}
        <a className="mk-link-arrow" href="/pricing" data-testid="pricing-full-link">See full pricing <ArrowRight size={16} aria-hidden="true" /></a>
      </div>
    </div>
  </section>
);
